// extracted by mini-css-extract-plugin
export default {"grouper":"LeftSidebar_grouper__OAdTl"};